import { NameValuePair, Result } from "../models/interfaces";
import { ApiMethods } from "./apiService";
import authService from "./authService";

const httpMethod = {
  POST: "POST",
  GET: "GET",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
};

export class BaseService {
  getTokenHeader() {
    const token = authService.getCurrentUserToken();
    return token !== undefined && token !== null
      ? { Authorization: "Bearer " + token.accessToken }
      : null;
  }

  getBaseUrl(): string {
    // return "https://localhost:7002/";
    return "https://coopman-api.mamretechnologies.net/";
  }

  ToQueryString<T>(params: T | any): string {
    return "";
  }

  ToFormData<T>(params: T | any): FormData {
    const formData = new FormData();
    for (const [key, value] of Object.entries(params as any)) {
      if (key.indexOf("img") !== -1 || key.indexOf("image") !== -1) {
        let fileInfo: { fileName: string; file: any } = {
          file: Object.create({}),
          fileName: "fileName",
        };
        formData.append(key, fileInfo.file, fileInfo.fileName);
      } else {
        formData.append(key, value as string);
      }
    }

    return formData;
  }

  async _apiCall<T>(
    url: string,
    method: ApiMethods,
    params?: T | object | FormData | any,
    isForm: boolean = false,
    headers?: NameValuePair[]
  ): Promise<T> {
    let res: T | any = null;
    try {
      const getHeaderType = () =>
        isForm ? "multipart-form" : "application/json";

      url = this.getBaseUrl() + url;

      const tokenHeaderValue = this.getTokenHeader();
      const request: RequestInit = {
        method: method,
        headers: {
          ...this.getTokenHeader(),
          "Content-Type": `${getHeaderType()}`,
        },
      };

      const actionMethods: string[] = [
        httpMethod.DELETE,
        httpMethod.POST,
        httpMethod.PUT,
      ];

      const methodType: string = method;
      if (actionMethods.includes(methodType.toUpperCase())) {
        if (params !== undefined && !isForm) {
          request.body = JSON.stringify(params);
        } else {
          request.body = params;
        }
      }

      const resp = await fetch(url, request);
      if (resp.status === 401) {
        // this means the user authentication has expired or the user is not logged in..
        window.location.href = "../login";
      }

      res = await resp.json();
    } catch (er) {
      console.log(er);
    }

    return res;
  }

  /**Gets the request from the server using the get method
   * This method should not be used to send data to the server
   */
  async get<T>(
    url: string,
    params?: T | T[] | any
  ): Promise<T | Result<T> | any> {
    if (params !== undefined) {
      url += this.ToQueryString(params);
    }

    const respData = this._apiCall<Result<T> | T | any>(url, "GET");
    return respData;
  }

  /**Post the request to the server using the POST method
   * This method can also be used to fetch data from the server
   */
  async post<T>(
    url: string,
    params: any = undefined,
    isForm?: boolean
  ): Promise<T | Result<T> | any> {
    return this._apiCall<Result<T> | T | any>(url, "POST", params, isForm);
  }

  /**Post the request to the server using the DELETE method */
  async delete<T>(
    url: string,
    params: any = undefined
  ): Promise<Result<T> | T | any> {
    return this._apiCall<Result<T> | T | any>(url, "DELETE", params, false);
  }

  /**Updates the resource on the server using the PUT command */
  async put<T>(
    url: string,
    params: T | any | undefined,
    isForm: boolean = false
  ): Promise<Result<T> | T | any> {
    return this._apiCall<Result<T> | T | any>(url, "PUT", params, isForm);
  }

  /**Updates a part of the result on the server using a PATCH command */
  async patch<T>(
    url: string,
    params: T | any | undefined = undefined,
    isForm: boolean = false
  ): Promise<Result<T> | T | any> {
    return this._apiCall<Result<T> | T | any>(url, "PATCH", params, isForm);
  }
}
